// Copyright (c) StrangeBee 2024

import { OrganisationLinksOutput, OrganisationOutput } from 'thehive-sdk';

export const getAvailableLinks = (links: OrganisationLinksOutput[], orgList: OrganisationOutput[]) => {
    return links.filter(({ toOrganisation }) => {
        return orgList.find(({ name, locked }) => name === toOrganisation && !locked);
    });
};
